import React from 'react'

const NotificationContainer: React.FC = () => {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {/* Notifications will be rendered here */}
    </div>
  )
}

export default NotificationContainer